// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Operator } from './Operator';
import {
    OperatorFromJSON,
    OperatorFromJSONTyped,
    OperatorToJSON,
    OperatorToJSONTyped,
} from './Operator';
import type { TariffZone } from './TariffZone';
import {
    TariffZoneFromJSON,
    TariffZoneFromJSONTyped,
    TariffZoneToJSON,
    TariffZoneToJSONTyped,
} from './TariffZone';
import type { VehicleMode } from './VehicleMode';
import {
    VehicleModeFromJSON,
    VehicleModeFromJSONTyped,
    VehicleModeToJSON,
    VehicleModeToJSONTyped,
} from './VehicleMode';
import type { Quay } from './Quay';
import {
    QuayFromJSON,
    QuayFromJSONTyped,
    QuayToJSON,
    QuayToJSONTyped,
} from './Quay';
import type { Point } from './Point';
import {
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
    PointToJSONTyped,
} from './Point';

/**
 * A place (de:Haltestelle) comprising one or more areas where vehicles may stop and where passengers may board or leave vehicles or prepare their trip. The name is given in regional language only.<br>Inherited from `Place`.<br>Inherited from `Place`.
 * @export
 * @interface StopPlaceDetailed
 */
export interface StopPlaceDetailed {
    /**
     * **Inheritance discriminator to proper Subclass** (technical field required by [OpenApi 3 Discriminator](https://swagger.io/docs/specification/data-models/inheritance-and-polymorphism/)) makes deserialization at consumer side easier.
     * @type {string}
     * @memberof StopPlaceDetailed
     * @deprecated
     */
    type: string;
    /**
     * Unique id referable by underlying system(s).
     * @type {string}
     * @memberof StopPlaceDetailed
     */
    id: string;
    /**
     * Unique non-translated name of Place.
     * @type {string}
     * @memberof StopPlaceDetailed
     */
    name: string;
    /**
     * Swiss location id (SLOID) from Atlas. More on [Service Points (Atlas) API](https://developer.sbb.ch/apis/atlas/documentation) > GET /service-point-directory/v1/service-points.
     * @type {string}
     * @memberof StopPlaceDetailed
     */
    swissLocationId?: string;
    /**
     * In CH this represents the 'district' name.
     * @type {string}
     * @memberof StopPlaceDetailed
     */
    province?: string;
    /**
     * In CH this represents the 'canton' abbreviation.
     * @type {string}
     * @memberof StopPlaceDetailed
     */
    canton?: string;
    /**
     * The two uppercase character of ISO 3166 code, mostly similar to lowercase IANA identifier (source: DiDok geographic-based _isoCountryCode_).
     * @type {string}
     * @memberof StopPlaceDetailed
     */
    countryCode?: string;
    /**
     * 
     * @type {Point}
     * @memberof StopPlaceDetailed
     */
    centroid?: Point;
    /**
     * 
     * @type {Operator}
     * @memberof StopPlaceDetailed
     */
    operator?: Operator;
    /**
     * Specifies the distance in [m] to the given coordinates in request. (Only set for `v3/places/by-coordinates*`).
     * @type {number}
     * @memberof StopPlaceDetailed
     */
    distanceToSearchPosition?: number;
    /**
     * Boundary for fare calculation resp. whether the **stop represents a tariff border between Switzerland and a neighbouring country**, where _true_ is based on a NOVA Tariff-BorderPoint (and must not be missunderstand by [UIC borderpoints](https://uic.org/support-activities/it/article/border-points).
     * @type {boolean}
     * @memberof StopPlaceDetailed
     */
    tariffBorder: boolean;
    /**
     * 
     * @type {Array<TariffZone>}
     * @memberof StopPlaceDetailed
     */
    tariffZones: Array<TariffZone>;
    /**
     * The higher the traffic load/importance the higher the value, null if unknown.
     * @type {number}
     * @memberof StopPlaceDetailed
     */
    weighting?: number;
    /**
     * 
     * @type {Set<VehicleMode>}
     * @memberof StopPlaceDetailed
     */
    vehicleModes: Set<VehicleMode>;
    /**
     * 
     * @type {Array<Quay>}
     * @memberof StopPlaceDetailed
     */
    quays: Array<Quay>;
    /**
     * A classification for a StopPlace:<br>x-extensible-enum: [SIMPLE, COMPLEX, ZONED, VIRTUAL] as in `StopPlaceClassification`
     * - `SIMPLE` just a non-grouped stop (typically for a concrete VehicleMode)
     * - `COMPLEX` a grouped concrete StopPlace (typically shared among different operators like Bern)
     * - `ZONED` a grouped topographically extended Stop (typically not ONE concrete StopPlace but a set of them like Paris)
     * - `VIRTUAL` a touristic non-real edge-point like 'Bahn-2000-Strecke' (has never leader or members)
     * @type {string}
     * @memberof StopPlaceDetailed
     */
    classification: string;
    /**
     * Pointer to `StopPlace` which acts as leader of this COMPLEX or ZONED, if so.
     * @type {string}
     * @memberof StopPlaceDetailed
     */
    leader?: string;
    /**
     * Contains members of this `StopPlace` of either type COMPLEX or ZONED, if any.
     * @type {Array<string>}
     * @memberof StopPlaceDetailed
     */
    members: Array<string>;
}

/**
 * Check if a given object implements the StopPlaceDetailed interface.
 */
export function instanceOfStopPlaceDetailed(value: object): value is StopPlaceDetailed {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tariffBorder' in value) || value['tariffBorder'] === undefined) return false;
    if (!('tariffZones' in value) || value['tariffZones'] === undefined) return false;
    if (!('vehicleModes' in value) || value['vehicleModes'] === undefined) return false;
    if (!('quays' in value) || value['quays'] === undefined) return false;
    if (!('classification' in value) || value['classification'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function StopPlaceDetailedFromJSON(json: any): StopPlaceDetailed {
    return StopPlaceDetailedFromJSONTyped(json, false);
}

export function StopPlaceDetailedFromJSONTyped(json: any, ignoreDiscriminator: boolean): StopPlaceDetailed {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'],
        'name': json['name'],
        'swissLocationId': json['swissLocationId'] == null ? undefined : json['swissLocationId'],
        'province': json['province'] == null ? undefined : json['province'],
        'canton': json['canton'] == null ? undefined : json['canton'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'centroid': json['centroid'] == null ? undefined : PointFromJSON(json['centroid']),
        'operator': json['operator'] == null ? undefined : OperatorFromJSON(json['operator']),
        'distanceToSearchPosition': json['distanceToSearchPosition'] == null ? undefined : json['distanceToSearchPosition'],
        'tariffBorder': json['tariffBorder'],
        'tariffZones': ((json['tariffZones'] as Array<any>).map(TariffZoneFromJSON)),
        'weighting': json['weighting'] == null ? undefined : json['weighting'],
        'vehicleModes': (new Set((json['vehicleModes'] as Array<any>).map(VehicleModeFromJSON))),
        'quays': ((json['quays'] as Array<any>).map(QuayFromJSON)),
        'classification': json['classification'],
        'leader': json['leader'] == null ? undefined : json['leader'],
        'members': json['members'],
    };
}

  export function StopPlaceDetailedToJSON(json: any): StopPlaceDetailed {
      return StopPlaceDetailedToJSONTyped(json, false);
  }

  export function StopPlaceDetailedToJSONTyped(value?: StopPlaceDetailed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'id': value['id'],
        'name': value['name'],
        'swissLocationId': value['swissLocationId'],
        'province': value['province'],
        'canton': value['canton'],
        'countryCode': value['countryCode'],
        'centroid': PointToJSON(value['centroid']),
        'operator': OperatorToJSON(value['operator']),
        'distanceToSearchPosition': value['distanceToSearchPosition'],
        'tariffBorder': value['tariffBorder'],
        'tariffZones': ((value['tariffZones'] as Array<any>).map(TariffZoneToJSON)),
        'weighting': value['weighting'],
        'vehicleModes': (Array.from(value['vehicleModes'] as Set<any>).map(VehicleModeToJSON)),
        'quays': ((value['quays'] as Array<any>).map(QuayToJSON)),
        'classification': value['classification'],
        'leader': value['leader'],
        'members': value['members'],
    };
}

